﻿
export enum NivEventStatus {
  Done = 0,
  inProgress = 1,
}
